import { validateField } from "@routes/Keyword/templates/AseanInsights/components/DownloadForm/actions/helpers/helpers";
import { z } from "zod";

export const countrySchema = z.string().min(1, { message: "Required" });

export const sectorSchema = z.string().min(1, { message: "Required" });

export const senioritySchema = z.string().min(1, { message: "Required" });

export const emailSchema = z.preprocess(
  (value) => value ?? "",
  z
    .string()
    .trim()
    .min(1, { message: "Required" })
    .pipe(
      z.email({
        message: "Invalid email format",
      })
    )
);

export const nameSchema = z.string().trim().min(1, { message: "Required" });

export const designationSchema = z
  .string()
  .trim()
  .min(1, { message: "Required" });

export const otherSectorSchema = z
  .string()
  .trim()
  .min(1, { message: "Required" });

export const newsletterSignupConsentSchema = z.boolean().optional();

export const legalConsentSchema = z
  .boolean()
  .default(false)
  .refine((value) => value, {
    message: "Please accept the terms to continue",
  });

export const submitFormSchema = z
  .object({
    // accept raw values here (FormData can be `null`) and validate all fields in superRefine
    name: z.unknown(),
    email: z.unknown(),
    sector: z.unknown(),
    country: z.unknown(),
    seniority: z.unknown(),
    otherSector: z.unknown(),
    designation: z.unknown(),
    legalConsent: z.unknown(),
  })
  .partial()
  .superRefine((data, ctx) => {
    validateField(ctx, "name", nameSchema, data.name);
    validateField(ctx, "email", emailSchema, data.email);
    validateField(ctx, "sector", sectorSchema, data.sector);
    validateField(ctx, "country", countrySchema, data.country);
    validateField(ctx, "seniority", senioritySchema, data.seniority);
    validateField(ctx, "designation", designationSchema, data.designation);
    validateField(ctx, "legalConsent", legalConsentSchema, data.legalConsent);

    if (data.sector !== "OTHERS") return;

    validateField(ctx, "otherSector", otherSectorSchema, data.otherSector);
  });
